import React from 'react';
import { Link } from 'react-router-dom';
import { channels } from '../../test.data';
import { Channel } from '../../types/channel.types';
import Container from '../containers/container';
import { ChannelDropdown } from '../dropdown/channel.dropdown';
import Avatar from '../images/avatar';
import { HStack, VStack } from '../layouts/stack.layout';
import Text from '../typography/v2/text';

type ChannelsQuery = 'GROUP' | 'DIRECT';

type Props = {
  query: ChannelsQuery;
};

export default function ChannelList({ query }: Props) {
  const queriedChannels: Channel[] = GET[query]();

  return (
    <>
      {queriedChannels.length ? (
        <VStack extensions="channels-list">
          {queriedChannels.map(({ id, backgroundImage, title }) => (
            <Link
              key={`avatar-${id}`}
              to={`/channels/${id}`}
              className="w-full"
            >
              {backgroundImage && id && title && (
                <HStack
                  gap="sm"
                  justify="between"
                  extensions="relative items-center hover:bg-white/[5%] ease-in transition-colors w-full p-2 channel-item"
                >
                  <HStack gap="sm" extensions="items-center">
                    <Avatar alt={title} url={backgroundImage} size="xs" />
                    <Text>{title}</Text>
                  </HStack>
                  <div className="more-button">
                    <ChannelDropdown id={id} />
                  </div>
                </HStack>
              )}
            </Link>
          ))}
        </VStack>
      ) : (
        <Container extensions="p-2">
          <Text color="info" variant="label">
            No Messages
          </Text>
        </Container>
      )}
    </>
  );
}

const GET: { [key in ChannelsQuery]: Function } = {
  GROUP: (): Channel[] =>
    channels.filter((channel) => channel.hasJoined === true),
  DIRECT: (): Channel[] => [],
};
